import { PublicServerPlaceEvent } from 'gleblu-socket-api';

import socket from '../../socket/socket';

export default function* getPublicResponse<T>(eventName: PublicServerPlaceEvent, eventParam: object): IterableIterator<Promise<T>> {
  return yield new Promise<T>((resolve) => socket.emit(eventName, eventParam, resolve));
}
